/**
 * At 1200px+ show all announcement blocks in one row (v4 top bar).
 * Pauses autoplay and restores keyboard access to every message link.
 */
(function () {
  var mq = window.matchMedia("(min-width: 1200px)");

  function roots() {
    return document.querySelectorAll(
      ".shopify-section-group-header-group slideshow-component.announcement-bar, #shopify-section-group-header-group slideshow-component.announcement-bar"
    );
  }

  function apply() {
    var wide = mq.matches;
    roots().forEach(function (root) {
      var slider = root.querySelector('[id^="Slider-"]');
      var slides = root.querySelectorAll(".slideshow__slide");
      if (!slider || slides.length < 2) return;

      if (wide) {
        if (typeof root.pause === "function") root.pause();
        slides.forEach(function (slide) {
          slide.setAttribute("aria-hidden", "false");
          slide.removeAttribute("tabindex");
          slide.querySelectorAll("a").forEach(function (a) {
            a.removeAttribute("tabindex");
          });
        });
      } else {
        if (slider.getAttribute("data-autoplay") === "true" && typeof root.play === "function") {
          root.play();
        }
        slider.dispatchEvent(new Event("scroll"));
      }
    });
  }

  if (mq.addEventListener) {
    mq.addEventListener("change", apply);
  } else if (mq.addListener) {
    mq.addListener(apply);
  }

  document.addEventListener("shopify:section:load", apply);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      requestAnimationFrame(apply);
    });
  } else {
    requestAnimationFrame(apply);
  }
})();
